import { SolRouteId, SolRouteIds } from '@sol/components';

export class AsmRouteId {
  // Apps
  public static readonly app_platform: SolRouteId = '';
  public static readonly app_partner: SolRouteId = 'partner';
  public static readonly app_admin: SolRouteId = 'admin';
  public static readonly app_licensing: SolRouteId = '';
  public static readonly app_licensing_external: SolRouteId = 'licensing-app';
  public static readonly app_sol_catalog: SolRouteId = 'sol-catalog';
  public static readonly app_asm_prototype: SolRouteId = 'asm-prototype';

  // Error
  public static readonly error: SolRouteId = SolRouteIds.error;
  public static readonly insufficient_auth: SolRouteId = 'insufficient-auth';

  // Dashboard
  public static readonly dashboard: SolRouteId = AsmRouteId.app_platform;

  // Tracker
  public static readonly tracker: SolRouteId = 'tracker';
  public static readonly tracker_detail: SolRouteId = 'tracker/:id';
  public static readonly tracker_detail_overview: SolRouteId = 'tracker/:id/overview';
  public static readonly tracker_detail_activity: SolRouteId = 'tracker/:id/activity';

  // DRP
  public static readonly drp: SolRouteId = 'drp';
  public static readonly drp_credentials: SolRouteId = 'credentials';
  public static readonly drp_darkWeb: SolRouteId = 'dark-web';
  public static readonly drp_darkWeb_detail: SolRouteId = 'dark-web/:id';
  public static readonly drp_darkWeb_detail_overview: SolRouteId = 'dark-web/:id/overview';
  public static readonly drp_darkWeb_detail_activity: SolRouteId = 'dark-web/:id/activity';
  public static readonly drp_dataLeakage: SolRouteId = 'data-leakage';
  public static readonly drp_dataLeakage_detail: SolRouteId = 'data-leakage/:id';
  public static readonly drp_dataLeakage_detail_overview: SolRouteId = 'data-leakage/:id/overview';
  public static readonly drp_dataLeakage_detail_activity: SolRouteId = 'data-leakage/:id/activity';
  public static readonly drp_mobileApps: SolRouteId = 'mobile-apps';
  public static readonly drp_mobileApps_detail: SolRouteId = 'mobile-apps/:id';
  public static readonly drp_mobileApps_detail_overview: SolRouteId = 'mobile-apps/:id/overview';
  public static readonly drp_mobileApps_detail_activity: SolRouteId = 'mobile-apps/:id/activity';
  public static readonly drp_socialMedia: SolRouteId = 'social-media';
  public static readonly drp_socialMedia_detail: SolRouteId = 'social-media/:id';
  public static readonly drp_socialMedia_detail_overview: SolRouteId = 'social-media/:id/overview';
  public static readonly drp_socialMedia_detail_activity: SolRouteId = 'social-media/:id/activity';

  // Assets
  public static readonly assets: SolRouteId = 'assets';
  public static readonly assets_domainDiscovery: SolRouteId = 'domain-discovery';
  public static readonly assets_domainDiscovery_detail: SolRouteId = 'domain-discovery/:id';
  public static readonly assets_domainDiscovery_detail_overview: SolRouteId = 'domain-discovery/:id/overview';
  public static readonly assets_domainDiscovery_detail_activity: SolRouteId = 'domain-discovery/:id/activity';
  public static readonly assets_domains: SolRouteId = 'domains';
  public static readonly assets_domains_detail: SolRouteId = 'domains/:id';
  public static readonly assets_domains_detail_overview: SolRouteId = 'domains/:id/overview';
  public static readonly assets_domains_detail_findings: SolRouteId = 'domains/:id/findings';
  public static readonly assets_domains_detail_scoring: SolRouteId = 'domains/:id/scoring';
  public static readonly assets_hosts_detail: SolRouteId = 'hosts/:id';
  public static readonly assets_hosts_detail_overview: SolRouteId = 'hosts/:id/overview';
  public static readonly assets_hosts_detail_findings: SolRouteId = 'hosts/:id/findings';
  public static readonly assets_hosts_detail_scoring: SolRouteId = 'hosts/:id/scoring';
  public static readonly assets_hosts_detail_scanHistory: SolRouteId = 'hosts/:id/scan-history';
  public static readonly assets_websites_detail: SolRouteId = 'websites/:id';
  public static readonly assets_websites_detail_overview: SolRouteId = 'websites/:id/overview';
  public static readonly assets_websites_detail_findings: SolRouteId = 'websites/:id/findings';
  public static readonly assets_websites_detail_scoring: SolRouteId = 'websites/:id/scoring';
  public static readonly assets_certificates_detail: SolRouteId = 'certificates/:id';
  public static readonly assets_certificates_detail_overview: SolRouteId = 'certificates/:id/overview';
  public static readonly assets_certificates_detail_findings: SolRouteId = 'certificates/:id/findings';
  public static readonly assets_certificates_detail_scoring: SolRouteId = 'certificates/:id/scoring';
  public static readonly assets_websites: SolRouteId = 'websites';
  public static readonly assets_hosts: SolRouteId = 'hosts';
  public static readonly assets_certificates: SolRouteId = 'certificates';

  // Insights
  public static readonly insights: SolRouteId = 'insights';
  public static readonly insights_reports: SolRouteId = 'reports';
  public static readonly insights_reports_overview: SolRouteId = 'reports/overview';
  public static readonly insights_reports_instances: SolRouteId = 'reports/instances';
  public static readonly insights_reports_instance_detail: SolRouteId = 'reports/instances/:id';
  public static readonly insights_reports_templates: SolRouteId = 'reports/templates';
  public static readonly insights_reports_template_detail: SolRouteId = 'reports/templates/:id';
  public static readonly insights_reports_template_generate: SolRouteId = 'reports/templates/:id/generate';
  public static readonly insights_vulnerability_catalog: SolRouteId = 'vulnerability-catalog';
  public static readonly insights_vulnerability_catalog_dashboard: SolRouteId = 'vulnerability-catalog/dashboard';
  public static readonly insights_vulnerability_catalog_list: SolRouteId = 'vulnerability-catalog/catalog';
  public static readonly insights_vulnerability_catalog_detail: SolRouteId = 'vulnerability-catalog/catalog/:id';
  public static readonly insights_threat_explorer: SolRouteId = 'threat-explorer';
  public static readonly insights_threat_explorer_asset: SolRouteId = 'threat-explorer/:id';

  // Administration (umbrella; `settings` kept as a back-compat redirect anchor)
  public static readonly administration: SolRouteId = 'administration';
  public static readonly settings: SolRouteId = 'settings';

  // Administration › Access management
  public static readonly administration_accessManagement: SolRouteId = 'access-management';
  public static readonly settings_accessControl: SolRouteId = 'access-control';
  public static readonly settings_accessControl_users: SolRouteId = 'access-control/users';
  public static readonly settings_accessControl_roles: SolRouteId = 'access-control/roles';
  public static readonly settings_api: SolRouteId = 'api';
  public static readonly settings_api_tokens: SolRouteId = 'api/tokens';
  public static readonly settings_api_docs: SolRouteId = 'api/docs';

  // Administration › Monitoring
  public static readonly administration_monitoring: SolRouteId = 'monitoring';
  public static readonly settings_auditLogs: SolRouteId = 'audit-logs';
  public static readonly settings_automation: SolRouteId = 'automation';
  public static readonly settings_integrations: SolRouteId = 'integrations';
  public static readonly settings_notifications: SolRouteId = 'notifications';

  // Administration › Resources
  public static readonly administration_resources: SolRouteId = 'resources';
  public static readonly settings_savedSearches: SolRouteId = 'saved-searches';
  public static readonly settings_tags: SolRouteId = 'tags';
  public static readonly settings_tags_user: SolRouteId = 'tags/user';
  public static readonly settings_tags_system: SolRouteId = 'tags/system';

  // Administration › Scope
  public static readonly settings_scope_settings: SolRouteId = 'settings/scope-settings';
  public static readonly settings_scope: SolRouteId = 'settings/scope';
  public static readonly settings_scope_overview: SolRouteId = 'settings/scope/overview';
  public static readonly settings_scope_seeds: SolRouteId = 'settings/scope/seeds';
  public static readonly settings_scope_subscopes: SolRouteId = 'settings/scope/subscopes';
  public static readonly settings_manualScans: SolRouteId = 'settings/manual-scans';

  // Usage
  public static readonly usage: SolRouteId = 'usage';
  public static readonly usage_overview: SolRouteId = 'usage/overview';
  public static readonly usage_events: SolRouteId = 'usage/events';

  // Services
  public static readonly services: SolRouteId = 'services';

  // Engagement requests (canonical paths — used in both standalone and host-bridge embedded mode)
  public static readonly engagementRequests: SolRouteId = 'engagements';
  public static readonly engagementRequests_overview: SolRouteId = 'engagements/overview';
  public static readonly engagementRequests_list: SolRouteId = 'engagements/list';
  public static readonly engagementRequests_accounts: SolRouteId = 'engagements/accounts';
  public static readonly engagementRequests_detail: SolRouteId = 'engagements/:id';
  public static readonly engagementRequests_detail_overview: SolRouteId = 'engagements/:id/overview';
  public static readonly engagementRequests_detail_comments: SolRouteId = 'engagements/:id/comments';

  // Partner
  public static readonly partner_dashboard: SolRouteId = 'partner';

  // Partner: scopes
  public static readonly partner_scopes: SolRouteId = 'partner/scopes';
  public static readonly partner_scopes_scope: SolRouteId = 'partner/scopes/:id';
  public static readonly partner_scopes_scope_overview: SolRouteId = 'partner/scopes/:id/overview';
  public static readonly partner_scopes_scope_modules: SolRouteId = 'partner/scopes/:id/modules';

  // Partner: access management
  public static readonly partner_access_management: SolRouteId = 'partner/access-management';
  public static readonly partner_users: SolRouteId = 'partner/users';
  public static readonly partner_roles: SolRouteId = 'partner/roles';
  public static readonly partner_api: SolRouteId = 'partner/api';
  public static readonly partner_api_tokens: SolRouteId = 'partner/api/tokens';
  public static readonly partner_api_docs: SolRouteId = 'partner/api/docs';

  // Partner: monitoring
  public static readonly partner_monitoring: SolRouteId = 'partner/monitoring';
  public static readonly partner_integrations: SolRouteId = 'partner/integrations';
  public static readonly partner_auditLogs: SolRouteId = 'partner/audit-logs';

  // Partner: usage
  public static readonly partner_usage: SolRouteId = 'partner/usage';
  public static readonly partner_usage_overview: SolRouteId = 'partner/usage/overview';
  public static readonly partner_usage_events: SolRouteId = 'partner/usage/events';

  // Partner: Resources
  public static readonly partner_resources: SolRouteId = 'partner/resources';

  // Settings
  public static readonly partner_settings: SolRouteId = 'partner/settings';
  public static readonly partner_settings_definitions: SolRouteId = 'partner/settings/definitions';
  public static readonly partner_settings_rules: SolRouteId = 'partner/settings/rules';

  // Admin: usage
  public static readonly admin_billing: SolRouteId = 'admin/usage/billing';
  public static readonly admin_billing_overview: SolRouteId = 'admin/usage/billing/overview';
  public static readonly admin_billing_events: SolRouteId = 'admin/usage/billing/events';

  // System
  public static readonly downloads: SolRouteId = 'downloads';
  public static readonly whatsNew: SolRouteId = 'whats-new';
  public static readonly decrypt: SolRouteId = 'decrypt';
  public static readonly debug: SolRouteId = 'debug';

  // Account
  public static readonly account: SolRouteId = 'account';
  // TODO(account-section-naming): placeholder routes — rename when account sections are named
  public static readonly account_section1: SolRouteId = 'account/section1';
  public static readonly account_documentation: SolRouteId = 'docs';
  public static readonly account_profile: SolRouteId = 'profile';
  public static readonly account_preferences: SolRouteId = 'preferences';
  // TODO(account-section-naming): placeholder routes — rename when account sections are named
  public static readonly account_section2: SolRouteId = 'account/section2';
  public static readonly account_logout: SolRouteId = 'logout';

  // Admin
  public static readonly admin_dashboard: SolRouteId = 'admin';
  public static readonly admin_partners: SolRouteId = 'admin/partners';

  // Admin: access management
  public static readonly admin_access_management: SolRouteId = 'admin/access-management';
  public static readonly admin_users: SolRouteId = 'admin/users';
  public static readonly admin_roles: SolRouteId = 'admin/roles';
  public static readonly admin_api: SolRouteId = 'admin/api';
  public static readonly admin_api_tokens: SolRouteId = 'admin/api/tokens';
  public static readonly admin_api_docs: SolRouteId = 'admin/api/docs';

  // Admin: derived access
  public static readonly admin_derived_access: SolRouteId = 'admin/derived-access';
  public static readonly admin_derived_roles: SolRouteId = 'admin/derived-access/derived-roles';
  public static readonly admin_access_reasons: SolRouteId = 'admin/derived-access/access-reasons';

  // Admin: licensing (Usage section)
  public static readonly admin_usage: SolRouteId = 'admin/usage';
  public static readonly licensing_dashboard: SolRouteId = AsmRouteId.app_licensing;
  public static readonly licensing_events: SolRouteId = 'events';
  public static readonly licensing_customers: SolRouteId = 'customers';
  public static readonly licensing_licenses: SolRouteId = 'licenses';
  public static readonly licensing_bundles: SolRouteId = 'bundles';
  public static readonly licensing_metrics: SolRouteId = 'metrics';
  public static readonly licensing_licenses_edit: SolRouteId = 'licenses/:id/edit';
  public static readonly licensing_units: SolRouteId = 'units';
  public static readonly licensing_actions: SolRouteId = 'actions';
  public static readonly licensing_documentation: SolRouteId = 'documentation';

  // ATP canonical routes (host-bridge child paths — /atp/* prefix)
  public static readonly atp: SolRouteId = 'atp';
  public static readonly atp_exposedAccounts: SolRouteId = 'atp/exposed-accounts';
  public static readonly atp_exposedAccounts_detail: SolRouteId = 'atp/exposed-accounts/:accountId';
  public static readonly atp_exposedAccounts_detail_overview: SolRouteId = 'atp/exposed-accounts/:accountId/overview';
  public static readonly atp_exposedAccounts_detail_scoring: SolRouteId = 'atp/exposed-accounts/:accountId/scoring';
  public static readonly atp_exposedAccounts_detail_activity: SolRouteId = 'atp/exposed-accounts/:accountId/activity';
  public static readonly atp_exposureArtifacts: SolRouteId = 'atp/exposure-artifacts';
  public static readonly atp_exposureArtifacts_detail: SolRouteId = 'atp/exposure-artifacts/:artifactId';
  public static readonly atp_exposureArtifacts_detail_overview: SolRouteId =
    'atp/exposure-artifacts/:artifactId/overview';
  public static readonly atp_exposureArtifacts_detail_scoring: SolRouteId =
    'atp/exposure-artifacts/:artifactId/scoring';
  public static readonly atp_exposureArtifacts_detail_activity: SolRouteId =
    'atp/exposure-artifacts/:artifactId/activity';
  public static readonly atp_exposedCookies: SolRouteId = 'atp/exposed-cookies';
  public static readonly atp_exposedCookies_detail: SolRouteId = 'atp/exposed-cookies/:cookieId';
  public static readonly atp_exposedCookies_detail_overview: SolRouteId = 'atp/exposed-cookies/:cookieId/overview';
  public static readonly atp_exposedCookies_detail_scoring: SolRouteId = 'atp/exposed-cookies/:cookieId/scoring';
  public static readonly atp_exposedCookies_detail_activity: SolRouteId = 'atp/exposed-cookies/:cookieId/activity';

  // Admin: Internal section
  public static readonly internal: SolRouteId = 'admin/internal';
  public static readonly internal_monitoring: SolRouteId = 'admin/internal-monitoring';
  public static readonly internal_tasks: SolRouteId = 'admin/internal-tasks';
  public static readonly internal_drp_sources: SolRouteId = 'admin/internal/drp-sources';
  public static readonly internal_drp_sources_modules: SolRouteId = 'admin/internal/drp-sources/modules';
  public static readonly internal_drp_sources_modules_module: SolRouteId = 'admin/internal/drp-sources/modules/:id';
  public static readonly internal_drp_sources_modules_module_overview: SolRouteId =
    'admin/internal/drp-sources/modules/:id/overview';
  public static readonly internal_drp_sources_sources: SolRouteId = 'admin/internal/drp-sources/sources';

  // Admin: Dashboard definitions
  public static readonly resources: SolRouteId = 'admin/resources';
  public static readonly dashboards: SolRouteId = 'admin/dashboards';
  public static readonly widgets: SolRouteId = 'admin/widget-types';
  public static readonly dashboards_definitions: SolRouteId = 'admin/dashboards/definitions';
  public static readonly dashboards_overview: SolRouteId = 'admin/dashboards/overview';
  public static readonly dashboards_detail: SolRouteId = 'admin/dashboards/overview/:dashboardId';
  public static readonly dataSources: SolRouteId = 'admin/data-sources';

  // Admin: Platform settings
  public static readonly admin_platform_settings: SolRouteId = 'admin/platform-settings';
  public static readonly admin_settings_definitions: SolRouteId = 'admin/platform-settings/definitions';
  public static readonly admin_settings_rules: SolRouteId = 'admin/platform-settings/rules';

  // Admin: Banners
  public static readonly banners: SolRouteId = 'admin/banners';

  // Admin: Smoke tests
  public static readonly admin_smoke_tests: SolRouteId = 'admin/smoke-tests';
  public static readonly admin_smoke_tests_suites: SolRouteId = 'admin/smoke-tests/suites';
  public static readonly admin_smoke_tests_runs: SolRouteId = 'admin/smoke-tests/runs';
  public static readonly admin_smoke_tests_run: SolRouteId = 'admin/smoke-tests/runs/:runId';
}
